import React, { useEffect, useState } from 'react';
import SuperadminLayout from '../../components/SuperadminLayout';
import { bankLabel } from '../../utils/bank';
import {
  approveKioskUnlockRequest, listKioskUnlockRequests, rejectKioskUnlockRequest,
} from '../../api/superadmin';
import './SuperadminKioskRequestsPage.css';

// Demandes envoyees par l'ecran cache "Kiosk Admin" de lottery-app —
// mode kiosque leger (bloque install/desinstall d'app, PAS un vrai
// lock-task plein ecran) : le POS demande le deblocage, SEUL un staff
// (superadmin ou compte limite) peut l'approuver/rejeter ici, jamais une
// company normale (backend: IsAdmin, banks/permissions.py).
const statusLabels = {
  pending: 'En attente',
  approved: 'Approuvé',
  rejected: 'Rejeté',
};

const SuperadminKioskRequestsPage = () => {
  const [requests, setRequests] = useState([]);
  const [statusFilter, setStatusFilter] = useState('pending');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState(null);

  const load = (filter) => {
    setLoading(true);
    setError('');
    listKioskUnlockRequests(filter)
      .then(setRequests)
      .catch(() => setError('Impossible de charger les demandes.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load('pending'); }, []);

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    load(value);
  };

  const handleDecision = async (id, action) => {
    setBusyId(id);
    setError('');
    try {
      const fn = action === 'approve' ? approveKioskUnlockRequest : rejectKioskUnlockRequest;
      const updated = await fn(id);
      setRequests((prev) => prev.map((r) => (r.id === id ? updated : r)));
    } catch (err) {
      let msg = 'Action impossible sur cette demande.';
      try {
        const parsed = JSON.parse(err.message);
        if (parsed && parsed.detail) msg = `${msg} — ${parsed.detail}`;
      } catch (_) {
        if (err.message) msg = `${msg} — ${err.message}`;
      }
      setError(msg);
    } finally {
      setBusyId(null);
    }
  };

  return (
    <SuperadminLayout>
      <h2 className="skr-title">Déblocages kiosque</h2>

      <div className="skr-filter-row">
        <label className="skr-filter-label">Statut</label>
        <select className="skr-filter-select" value={statusFilter} onChange={handleFilterChange}>
          <option value="">Tous</option>
          <option value="pending">En attente</option>
          <option value="approved">Approuvé</option>
          <option value="rejected">Rejeté</option>
        </select>
      </div>

      {error && <p className="skr-error">{error}</p>}
      {loading ? (
        <p>Chargement...</p>
      ) : (
        <table className="skr-table">
          <thead>
            <tr>
              <th>Banque</th>
              <th>Company</th>
              <th>Raison</th>
              <th>Demandé le</th>
              <th>Statut</th>
              <th>Décidé par</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.length === 0 && (
              <tr><td colSpan={7} className="skr-empty">Aucune demande.</td></tr>
            )}
            {requests.map((r) => (
              <tr key={r.id}>
                <td>{bankLabel(r.bank_seq, r.bank_name)} ({r.bank_username})</td>
                <td>{r.company_name}</td>
                <td>{r.reason || '—'}</td>
                <td>{new Date(r.requested_at).toLocaleString()}</td>
                <td>{statusLabels[r.status] || r.status}</td>
                <td>{r.decided_by || '—'}</td>
                <td>
                  {r.status === 'pending' ? (
                    <div className="skr-actions">
                      <button
                        className="skr-approve-btn"
                        disabled={busyId === r.id}
                        onClick={() => handleDecision(r.id, 'approve')}
                      >
                        Approuver
                      </button>
                      <button
                        className="skr-reject-btn"
                        disabled={busyId === r.id}
                        onClick={() => handleDecision(r.id, 'reject')}
                      >
                        Rejeter
                      </button>
                    </div>
                  ) : (
                    '—'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </SuperadminLayout>
  );
};

export default SuperadminKioskRequestsPage;
